<template>
  <v-card class="mx-auto" flat>
    <v-toolbar color="secondary" dark flat>
      <v-toolbar-title>{{ subtitle }}</v-toolbar-title>
    </v-toolbar>
    <v-container class="pa-5">
      <base-form-generator :schema="schema[role][type]" v-model="form" />
    </v-container>
  </v-card>
</template>

<script>
import BaseFormGenerator from '@/components/base/BaseFormGenerator';
import { getAge } from '@utils/format';

export default {
  name: 'InformasiDasar',
  components: { BaseFormGenerator },
  props: {
    subtitle: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    role: {
      type: String,
      required: true,
    },
    initValue: {
      type: Object,
      default: () => null,
    },
    masters: {
      type: Object,
      default: () => {},
    },
    mFungsi: {
      type: Object,
      default: () => {},
    },
    configs: {
      type: Object,
      default: () => {},
    },
    kSumber: {
      type: Number,
      default: null,
    },
    guru: {
      type: Boolean,
      default: true,
    },
    isAkunPkb: {
      type: Boolean,
      default: false,
    },
    gelombang: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      form: {},
      isUmum: false,
    };
  },
  computed: {
    kualifikasi() {
      let result = {};

      for (const k in this.masters.kualifikasi) {
        if (Number(k) > 1 && Number(k) < 12) {
          result[k] = this.masters.kualifikasi[k];
        }
      }

      return result;
    },

    schema() {
      const schemaPa = {
        dasar: [
          {
            type: 'VTextField',
            name: 'nama',
            label: 'Nama Lengkap',
            labelColor: 'info',
            hint: 'wajib diisi',
            grid: { cols: 12 },
            disabled: true,
            outlined: true,
            dense: true,
            singleLine: true,
          },
          {
            type: 'VTextField',
            name: 'nik',
            label: 'NIK',
            labelColor: 'info',
            hint: 'wajib diisi',
            grid: { cols: 12, md: 6 },
            mask: '################',
            disabled: !(this.initValue && this.initValue.is_update_nik),
            readOnly: true,
            counter: '16',
            outlined: true,
            dense: true,
            singleLine: true,
          },
          // {
          //   type: 'VTextField',
          //   name: 'no_hp',
          //   label: 'Nomor Telepon (HP)',
          //   labelColor: 'info',
          //   hint: 'wajib diisi',
          //   grid: { cols: 12, md: 6 },
          //   mask: '###############',
          //   disabled: true,
          //   outlined: true,
          //   dense: true,
          //   singleLine: true,
          // },
          {
            type: 'VTextField',
            name: 'no_wa',
            label: 'Nomor Telepon (terhubung WhatsApp)',
            labelColor: 'info',
            hint: 'wajib diisi',
            grid: { cols: 12, md: 6 },
            mask: '###############',
            disabled: true,
            outlined: true,
            dense: true,
            singleLine: true,
          },
          {
            type: 'VTextField',
            name: 'email',
            label: 'Alamat Surel',
            labelColor: 'info',
            hint: 'wajib diisi',
            grid: { cols: 12, md: 6 },
            disabled: true,
            outlined: true,
            dense: true,
            singleLine: true,
          },
          {
            type: 'VTextField',
            name: 'tmp_lahir',
            label: 'Tempat Lahir',
            labelColor: 'info',
            hint: 'wajib diisi',
            grid: { cols: 12, md: 6 },
            disabled: true,
            outlined: true,
            dense: true,
            singleLine: true,
          },
          {
            type: 'VDatePicker',
            name: 'tgl_lahir',
            label: 'Tanggal Lahir',
            labelColor: 'info',
            hint: 'wajib diisi',
            grid: { cols: 12, md: 6 },
            disabled: true,
            outlined: true,
            dense: true,
            singleLine: true,
          },
          {
            type: 'VTextField',
            name: 'usia',
            label: 'Usia',
            labelColor: 'info',
            hint: 'wajib diisi',
            grid: { cols: 12, md: 6 },
            disabled: true,
            outlined: true,
            dense: true,
            singleLine: true,
          },
          {
            type: 'VTextarea',
            name: 'alamat_ktp',
            label: 'Alamat (sesuai KTP)',
            labelColor: 'info',
            hint: 'wajib diisi',
            required: true,
            grid: { cols: 12 },
            outlined: true,
            dense: true,
            singleLine: true,
          },
          {
            type: 'cascade',
            labelColor: 'info',
            configs: this.configs && this.configs['ktp'],
            grid: { cols: 12 },
          },
          {
            type: 'VTextarea',
            name: 'alamat',
            label: 'Alamat Tinggal Sekarang',
            labelColor: 'info',
            hint: 'wajib diisi',
            grid: { cols: 12 },
            disabled: !(this.initValue && this.initValue.is_update_alamat),
            outlined: true,
            dense: true,
            singleLine: true,
          },
          {
            type: 'cascade',
            labelColor: 'info',
            configs: this.configs && this.configs['default'],
            grid: { cols: 12 },
          },
          {
            type: 'VTextField',
            name: 'kodepos',
            label: 'Kode Pos',
            labelColor: 'info',
            hint: 'wajib diisi',
            grid: { cols: 12, md: 6 },
            mask: '#####',
            required: true,
            outlined: true,
            dense: true,
            singleLine: true,
          },
        ],
        pendidikan: [
          {
            type: 'VSelect',
            name: 'k_kualifikasi',
            label: 'Pendidikan terakhir',
            labelColor: 'info',
            hint: 'wajib diisi',
            items: this.$mapForMaster(this.masters['kualifikasi']),
            itemText: 'text',
            itemValue: 'value',
            disabled: this.initValue && this.initValue.dapodik_ptk_id ? true : false,
            required: true,
            outlined: true,
            dense: true,
            singleLine: true,
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'VTextField',
            name: 'pendidikan_instansi',
            label: 'Nama instansi pendidikan terakhir',
            labelColor: 'info',
            hint: 'wajib diisi',
            grid: { cols: 12, md: 6 },
            required: true,
            outlined: true,
            dense: true,
            singleLine: true,
          },
          {
            type: 'VSelect',
            name: 'k_pendidikan_bidang_psp',
            label: 'Bidang Pendidikan Terakhir',
            labelColor: 'info',
            hint: 'wajib diisi',
            items: this.$mapForMaster(this.masters['pendidikan_bidang'], 'k_profil_opsi_psp'),
            itemText: 'text',
            itemValue: 'value',
            required: true,
            outlined: true,
            dense: true,
            singleLine: true,
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'VTextField',
            name: 'pendidikan_jurusan',
            label: 'Jurusan',
            labelColor: 'info',
            hint: 'wajib diisi',
            grid: { cols: 12, md: 6 },
            required: true,
            outlined: true,
            dense: true,
            singleLine: true,
          },
        ],
        tambahan: [
          {
            type: 'VTextField',
            name: 'instansi_nama',
            label: 'Nama Instansi',
            labelColor: 'info',
            hint: 'wajib diisi',
            grid: { cols: 12, md: this.form['k_kurikulum_psp'] === 17099 ? 6 : 12 },
            disabled: !this.isUmum,
            required: true,
            outlined: true,
            dense: true,
            singleLine: true,
          },
          {
            type: 'cascade',
            labelColor: 'info',
            configs: this.configs && this.configs['instansi'],
            grid: { cols: 12 },
          },
          {
            type: 'VTextarea',
            name: 'instansi_alamat',
            label: 'Alamat Instansi',
            labelColor: 'info',
            hint: 'wajib diisi',
            grid: { cols: 12 },
            required: true,
            outlined: true,
            dense: true,
            singleLine: true,
          },
          {
            type: 'VTextField',
            name: 'instansi_situs',
            label: 'Website Instansi',
            labelColor: 'info',
            grid: { cols: 12, md: 6 },
            outlined: true,
            dense: true,
            singleLine: true,
          },
        ],
        kurikulum: [
          {
            type: 'VSelect',
            name: 'k_kurikulum_psp',
            label: 'Jenis Kurikulum',
            labelColor: 'info',
            hint: 'wajib diisi',
            items: this.$mapForMaster(this.masters['kurikulum'], 'k_profil_opsi_psp'),
            itemText: 'text',
            itemValue: 'value',
            required: true,
            outlined: true,
            dense: true,
            singleLine: true,
            grid: { cols: 12, md: 6 },
          },
        ],
        pengawas: [
          {
            type: 'VSelect',
            name: 'k_jenjang_pengawas_psp',
            label: 'Jenjang Satuan Pendidikan Penugasan',
            labelColor: 'info',
            hint: 'wajib diisi',
            items: this.$mapForMaster(this.masters['jenjang_pengawas'], 'k_profil_opsi_psp'),
            itemText: 'text',
            itemValue: 'value',
            required: true,
            outlined: true,
            dense: true,
            singleLine: true,
            grid: { cols: 12, md: 6 },
          },
        ],
        profesi: [
          {
            type: 'VTextField',
            name: 'profesi',
            label: 'Apa profesi/pekerjaan Anda saat ini',
            labelColor: 'info',
            hint: 'wajib diisi',
            grid: { cols: 12, md: 6 },
            required: true,
            outlined: true,
            dense: true,
            singleLine: true,
          },
        ],
      };

      return {
        kasek: {
          dasar: [
            {
              type: 'VTextField',
              name: 'nama',
              label: 'Nama Lengkap',
              labelColor: 'info',
              hint: 'wajib diisi',
              grid: { cols: 12 },
              disabled: true,
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VTextField',
              name: 'no_ukg',
              label: 'Nomor UKG',
              labelColor: 'info',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              mask: '####################',
              disabled: true,
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VTextField',
              name: 'nik',
              label: 'NIK',
              labelColor: 'info',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              mask: '################',
              readOnly: true,
              required: true,
              counter: '16',
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VTextField',
              name: 'no_wa',
              label: 'Nomor Telepon (terhubung WhatsApp)',
              labelColor: 'info',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              mask: '###############',
              required: true,
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VTextField',
              name: 'email',
              label: 'Email (untuk Kontak)',
              labelColor: 'info',
              hint: 'wajib diisi',
              required: true,
              grid: { cols: 12, md: 6 },
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VTextField',
              name: 'tmp_lahir',
              label: 'Tempat Lahir',
              labelColor: 'info',
              hint: 'wajib diisi',
              disabled: true,
              grid: { cols: 12, md: 6 },
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VDatePicker',
              name: 'tgl_lahir',
              label: 'Tanggal Lahir',
              labelColor: 'info',
              hint: 'wajib diisi',
              disabled: true,
              grid: { cols: 12, md: 6 },
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VTextarea',
              name: 'alamat_ktp_dapodik',
              label: 'Alamat KTP (Dapodik)',
              labelColor: 'info',
              hint: '',
              required: false,
              grid: { cols: 12 },
              outlined: true,
              disabled: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'cascade',
              labelColor: 'info',
              configs: this.configs && this.configs['dapodik'],
              grid: { cols: 12 },
            },
            {
              type: 'VTextarea',
              name: 'alamat',
              label: 'Alamat Domisili',
              labelColor: 'info',
              hint: 'wajib diisi',
              required: true,
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'cascade',
              labelColor: 'info',
              configs: this.configs && this.configs.ptk,
              grid: { cols: 12 },
            },
            {
              type: 'VTextField',
              name: 'sekolah_id',
              label: 'Satminkal',
              labelColor: 'info',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              disabled: true,
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VTextField',
              name: 'jenjang',
              label: 'Jenjang',
              labelColor: 'info',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              disabled: true,
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'cascade',
              labelColor: 'info',
              configs: this.configs && this.configs['sekolah_dapodik'],
              grid: { cols: 12 },
            },
            {
              type: 'VTextField',
              name: 'tugas_id',
              label: 'Tugas Tambahan',
              labelColor: 'info',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              disabled: true,
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VSelect',
              name: 'k_kasek_lama_psp',
              label: 'Lama menjabat sebagai Kepala Satuan Pendidikan',
              labelColor: 'info',
              hint: 'wajib diisi',
              items: this.$mapForMaster(this.masters['kasek_lama'], 'k_profil_opsi_psp'),
              itemText: 'text',
              itemValue: 'value',
              required: true,
              outlined: true,
              dense: true,
              singleLine: true,
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'VSelect',
              name: 'k_kasek_sisa_psp',
              label: 'Sisa masa tugas sebagai kepala satuan pendidikan',
              labelColor: 'info',
              hint: 'wajib diisi',
              items: this.$mapForMaster(this.masters['kasek_sisa'], 'k_profil_opsi_psp'),
              itemText: 'text',
              itemValue: 'value',
              required: true,
              outlined: true,
              dense: true,
              singleLine: true,
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'VTextField',
              name: 'kualifikasi',
              label: 'Pendidikan terakhir',
              labelColor: 'info',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              disabled: true,
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VTextField',
              name: 'pendidikan_instansi',
              label: 'Nama instansi pendidikan terakhir',
              labelColor: 'info',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              required: true,
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'VSelect',
              name: 'k_pendidikan_bidang_psp',
              label: 'Bidang Pendidikan Terakhir',
              labelColor: 'info',
              hint: 'wajib diisi',
              items: this.$mapForMaster(this.masters['pendidikan_bidang'], 'k_profil_opsi_psp'),
              itemText: 'text',
              itemValue: 'value',
              required: true,
              outlined: true,
              dense: true,
              singleLine: true,
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'VTextField',
              name: 'pendidikan_jurusan',
              label: 'Jurusan',
              labelColor: 'info',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              required: true,
              outlined: true,
              dense: true,
              singleLine: true,
            },
          ],
        },
        instruktur: {
          pa: [
            ...schemaPa.dasar,
            ...([2].includes(Number(this.initValue && this.initValue.k_unsur_psp)) ? schemaPa.profesi : []),
            ...([10, 22, 23, 25].includes(Number(this.initValue && this.initValue.k_unsur_psp))
              ? this.form['k_kurikulum_psp'] === 17099
                ? [].concat(schemaPa.kurikulum, {
                    type: 'VTextField',
                    name: 'kurikulum_lain',
                    label: 'Jenis Kurikulum Lain',
                    labelColor: 'info',
                    hint: 'wajib diisi',
                    grid: { cols: 12, md: 6 },
                    outlined: true,
                    dense: true,
                    singleLine: true,
                  })
                : this.form['k_kurikulum_psp'] === 17010
                ? [].concat(schemaPa.kurikulum, {
                    type: 'VSelect',
                    name: 'k_kurikulum_internasional_psp',
                    label: 'K13 Plus Kurikulum Internasional',
                    labelColor: 'info',
                    hint: 'wajib diisi',
                    items: this.$mapForMaster(this.masters['kurikulum_internasional'], 'k_profil_opsi_psp'),
                    itemText: 'text',
                    itemValue: 'value',
                    required: true,
                    outlined: true,
                    dense: true,
                    singleLine: true,
                    grid: { cols: 12, md: 6 },
                  })
                : schemaPa.kurikulum
              : []),
            ...([21].includes(Number(this.initValue && this.initValue.k_unsur_psp)) ? schemaPa.pengawas : []),
            ...schemaPa.tambahan,
            ...schemaPa.pendidikan,
          ],
          tambahan: [
            {
              type: 'VSelect',
              name: 'tambahan_jenjang_prioritas',
              label:
                'Sebutkan jenjang satuan pendidikan yang menjadi prioritas untuk Bapak/Ibu dampingi jika terpilih sebagai Fasilitator? ',
              labelColor: 'info',
              hint: 'wajib diisi',
              items: this.$mapForMaster(this.masters['tambahan_jenjang_prioritas'], 'k_profil_opsi_psp'),
              itemText: 'text',
              itemValue: 'value',
              required: true,
              multiple: true,
              outlined: true,
              dense: true,
              singleLine: true,
              grid: { cols: 12 },
            },
            {
              type: 'VRadio',
              name: 'tambahan_instruktur_nasional',
              label:
                'Apakah Bapak/Ibu pernah atau sedang bertugas sebagai Instruktur Nasional Program Sekolah Penggerak?',
              hint: 'wajib diisi',
              items: this.$mapForMaster(this.masters['tambahan_instruktur_nasional'], 'k_profil_opsi_psp'),
              required: true,
              hideDetails: false,
              outlined: true,
              dense: true,
              row: true,
              singleLine: false,
              grid: { cols: 12 },
              labelColor: 'info',
            },
          ],
          mutu: [
            {
              type: 'VSelect',
              name: 'k_pendampingan_psp',
              label: 'Pengalaman melakukan pendampingan peningkatan mutu pendidikan',
              labelColor: 'info',
              hint: 'wajib diisi',
              items: this.$mapForMaster(this.masters['pendampingan'], 'k_profil_opsi_psp'),
              itemText: 'text',
              itemValue: 'value',
              required: true,
              outlined: true,
              dense: true,
              singleLine: true,
              grid: { cols: 12, md: 12 },
            },
          ],
        },
      };
    },
  },
  methods: {
    reset() {
      this.$set(this, 'form', {});
    },
    initForm(value) {
      this.$nextTick(() => {
        const formulir = [...this.schema[this.role][this.type]];
        for (const item of formulir) {
          if (item.name) {
            this.$set(this.form, item.name, this.$getDeepObj(value, item.name) || '');
          }
        }

        // set this umum
        this.isUmum = Boolean(Number(this.$getDeepObj(value, 'is_umum')));
        this.$set(this.form, 'k_propinsi', this.$getDeepObj(value, 'k_propinsi') || '');
        this.$set(this.form, 'k_kota', this.$getDeepObj(value, 'k_kota') || '');
        this.$set(this.form, 'k_propinsi_ktp', this.$getDeepObj(value, 'k_propinsi_ktp') || '');
        this.$set(this.form, 'k_kota_ktp', this.$getDeepObj(value, 'k_kota_ktp') || '');
        this.$set(this.form, 'k_propinsi_dapodik', this.$getDeepObj(value, 'k_propinsi_dapodik') || '');
        this.$set(this.form, 'k_kota_dapodik', this.$getDeepObj(value, 'k_kota_dapodik') || '');
        this.$set(this.form, 'k_propinsi_sekolah_dapodik', this.$getDeepObj(value, 'k_propinsi_sekolah_dapodik') || '');
        this.$set(this.form, 'k_kota_sekolah_dapodik', this.$getDeepObj(value, 'k_kota_sekolah_dapodik') || '');
        this.$set(this.form, 'jabatan_lain', this.$getDeepObj(value, 'jabatan_lain') || '');
        this.$set(this.form, 'instansi_k_propinsi', this.$getDeepObj(value, 'instansi_k_propinsi') || '');
        this.$set(this.form, 'instansi_k_kota', this.$getDeepObj(value, 'instansi_k_kota') || '');
        this.$set(
          this.form,
          'k_kurikulum_internasional_psp',
          this.$getDeepObj(value, 'k_kurikulum_internasional_psp') || ''
        );
        this.$set(this.form, 'kurikulum_lain', this.$getDeepObj(value, 'kurikulum_lain') || '');
      });
    },
    getValue() {
      return this.form;
    },
    fillUsia(value) {
      if (value) {
        const age = getAge(value);
        this.$set(this.form, 'usia', age || '-');
      }
    },
    checkJenjangPrioritas(value) {
      if (value.length > 2) {
        value.pop();
      }
    },
  },
  watch: {
    initValue: 'initForm',
    'form.tgl_lahir': 'fillUsia',
    'form.tambahan_jenjang_prioritas': 'checkJenjangPrioritas',
  },
};
</script>

<style scoped></style>
